var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	13732: {
		fallback: () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(65043))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	8122: {
		fallback: () => (__webpack_require__.e(950).then(() => (() => (__webpack_require__(97950))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	99722: {
		fallback: () => (Promise.all([__webpack_require__.e(426), __webpack_require__.e(623), __webpack_require__.e(201)]).then(() => (() => (__webpack_require__(3201))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@kne/react-fetch",

	},
	88228: {
		fallback: () => (Promise.all([__webpack_require__.e(4), __webpack_require__.e(726), __webpack_require__.e(830)]).then(() => (() => (__webpack_require__(71830))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@kne/current-lib_react-dock",

	},
	24934: {
		fallback: () => (Promise.all([__webpack_require__.e(426), __webpack_require__.e(467)]).then(() => (() => (__webpack_require__(31467))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@kne/remote-loader",

	},
	40147: {
		fallback: () => (Promise.all([__webpack_require__.e(81), __webpack_require__.e(53)]).then(() => (() => (__webpack_require__(77081))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "antd",

	},
	54539: {
		fallback: () => (__webpack_require__.e(245).then(() => (() => (__webpack_require__(53245))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	64626: {
		fallback: () => (Promise.all([__webpack_require__.e(308), __webpack_require__.e(714)]).then(() => (() => (__webpack_require__(7308))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@kne/react-intl",

	},
	93702: {
		fallback: () => (__webpack_require__.e(344).then(() => (() => (__webpack_require__(24344))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "axios",

	},
	8726: {
		fallback: () => (__webpack_require__.e(233).then(() => (() => (__webpack_require__(98233))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	66814: {
		fallback: () => (Promise.all([__webpack_require__.e(548), __webpack_require__.e(869)]).then(() => (() => (__webpack_require__(99548))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@kne/react-intl",

	},
	41714: {
		fallback: () => (__webpack_require__.e(247).then(() => (() => (__webpack_require__(20628))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@kne/global-context",

	},
	30158: {
		fallback: () => (__webpack_require__.e(257).then(() => (() => (__webpack_require__(39638))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@kne/global-context",

	},
	62648: {
		fallback: () => (__webpack_require__.e(355).then(() => (() => (__webpack_require__(41355))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@kne/react-fetch",

	},
	91053: {
		fallback: () => (__webpack_require__.e(446).then(() => (() => (__webpack_require__(60446))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "dayjs",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"53": [
		91053
	],
	"122": [
		8122
	],
	"228": [
		88228
	],
	"635": [
		24934,
		40147,
		54539,
		64626,
		93702
	],
	"714": [
		41714
	],
	"722": [
		99722
	],
	"726": [
		8726
	],
	"732": [
		13732
	],
	"830": [
		66814
	],
	"869": [
		30158,
		62648
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}